export function isArray(object: unknown): object is unknown[] {
  return Array.isArray(object);
}

// Rating Sub Categories removed from reviews
// function isRatingStars(data: object): data is ProductReview["ratingStars"] {
//   const validOverall = "overall" in data && typeof data.overall === "number";
//   const validShipping = "shipping" in data && typeof data.shipping === "number";
//   const validQuality = "quality" in data && typeof data.quality === "number";
//   const validPackaging =
//     "packaging" in data && typeof data.packaging === "number";
//   const validAsDescribed =
//     "asDescribed" in data && typeof data.asDescribed === "number";

//   const AllValid =
//     validOverall &&
//     validShipping &&
//     validQuality &&
//     validPackaging &&
//     validAsDescribed;

//   if (!AllValid) {
//     let errors = [];

//     if (!validOverall) {
//       if (!("overall" in data)) {
//         errors.push("overall is missing");
//       } else {
//         errors.push("overall is invalid");
//       }
//     }

//     if (!validShipping) {
//       if (!("shipping" in data)) {
//         errors.push("shipping is missing");
//       } else {
//         errors.push("shipping is invalid");
//       }
//     }

//     if (!validQuality) {
//       if (!("quality" in data)) {
//         errors.push("quality is missing");
//       } else {
//         errors.push("quality is invalid");
//       }
//     }

//     if (!validPackaging) {
//       if (!("packaging" in data)) {
//         errors.push("packaging is missing");
//       } else {
//         errors.push("packaging is invalid");
//       }
//     }

//     if (!validAsDescribed) {
//       if (!("asDescribed" in data)) {
//         errors.push("asDescribed is missing");
//       } else {
//         errors.push("asDescribed is invalid");
//       }
//     }

//     console.log("Invalid RatingStars");
//     console.log(data);
//     console.log(errors);
//   }

//   return AllValid;
// }

export function isCategory(data: object): data is Category {
  const validID = "id" in data && typeof data.id === "number";
  const validCategory = "category" in data && typeof data.category === "string";

  const AllValid = validID && validCategory;

  if (!AllValid) {
    let errors = [];

    if (!validID) {
      if (!("id" in data)) {
        errors.push("id is missing");
      } else {
        errors.push("id is invalid");
        console.log(data.id);
      }
    }

    if (!validCategory) {
      if (!("category" in data)) {
        errors.push("category is missing");
      } else {
        errors.push("category is invalid");
        console.log(data.category);
      }
    }
    console.log("Invalid Category");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isDepartment(data: object): data is Department {
  const validID = "id" in data && typeof data.id === "number";
  const validDepartment =
    "department" in data && typeof data.department === "string";
  const validBanner = "banner" in data && isImageObj(data.banner);
  const validSubDepartments =
    "subDepartments" in data &&
    Array.isArray(data.subDepartments) &&
    data.subDepartments.every(
      (subDepartment) =>
        typeof subDepartment === "object" &&
        subDepartment !== null &&
        "id" in subDepartment &&
        typeof subDepartment.id === "number" &&
        "name" in subDepartment &&
        typeof subDepartment.name === "string" &&
        "thumb" in subDepartment &&
        typeof subDepartment.thumb === "string"
    );

  const AllValid =
    validID && validDepartment && validBanner && validSubDepartments;

  if (!AllValid) {
    let errors = [];

    if (!validID) {
      if (!("id" in data)) {
        errors.push("id is missing");
      } else {
        errors.push("id is invalid");
        console.log(data.id);
      }
    }

    if (!validDepartment) {
      if (!("department" in data)) {
        errors.push("department is missing");
      } else {
        errors.push("department is invalid");
        console.log(data.department);
      }
    }

    if (!validBanner) {
      if (!("banner" in data)) {
        errors.push("banner is missing");
      } else {
        errors.push("banner is invalid");
        console.log(data.banner);
      }
    }

    if (!validSubDepartments) {
      if (!("subDepartments" in data)) {
        errors.push("subDepartments is missing");
      } else {
        errors.push("subDepartments is invalid");
        console.log(data.subDepartments);
      }
    }

    console.log("Invalid Department");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isSharedProduct(data: unknown): data is SharedProduct {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validID = "id" in data && typeof data.id === "number";

  const validTitle = "title" in data && typeof data.title === "string";

  const validCategoryID =
    "categoryID" in data && typeof data.categoryID === "number";

  const validStartingAmount =
    "startingAmount" in data && typeof data.startingAmount === "string";

  const validImage =
    "mainImage" in data &&
    (data.mainImage === null || isImageObj(data.mainImage));

  const validAuctionTime =
    "auctionTime" in data && typeof data.auctionTime === "string";
  const validBidType = "bidType" in data && typeof data.bidType === "string";

  const validStatus =
    "status" in data &&
    (data.status === "Not Started" ||
      data.status === "Open" ||
      data.status === "Closed" ||
      data.status === "Ended");

  const validBidBuddy =
    "bidBuddy" in data && typeof data.bidBuddy === "boolean";

  const validActiveBuddy =
    "activeBuddy" in data && typeof data.activeBuddy === "boolean";

  const validBuyNow = "buyNow" in data && typeof data.buyNow === "boolean";

  const validAuctionTimer =
    "auctionTimer" in data && typeof data.auctionTimer === "number";

  // buyNowPrice
  const validBuyNowPrice =
    "buyNowPrice" in data && typeof data.buyNowPrice === "string";

  const validBidBuddyAmount =
    "currentBidBuddyAmount" in data &&
    typeof data.currentBidBuddyAmount === "number";

  const AllValid =
    validID &&
    validTitle &&
    validCategoryID &&
    validStartingAmount &&
    validImage &&
    validAuctionTime &&
    validBidType &&
    validStatus &&
    validBidBuddy &&
    validActiveBuddy &&
    validBuyNow &&
    validBidBuddyAmount &&
    validAuctionTimer &&
    validBuyNowPrice;

  if (!AllValid) {
    let errors = [];

    if (!validID) {
      if (!("id" in data)) {
        errors.push("id is missing");
      } else {
        errors.push("id is invalid");
        console.log(data.id);
      }
    }

    if (!validTitle) {
      if (!("title" in data)) {
        errors.push("title is missing");
      } else {
        errors.push("title is invalid");
        console.log(data.title);
      }
    }

    if (!validCategoryID) {
      if (!("categoryID" in data)) {
        errors.push("categoryID is missing");
      } else {
        errors.push("categoryID is invalid");
        console.log(data.categoryID);
      }
    }

    if (!validStartingAmount) {
      if (!("startingAmount" in data)) {
        errors.push("startingAmount is missing");
      } else {
        errors.push("startingAmount is invalid");
        console.log(data.startingAmount);
      }
    }

    if (!validImage) {
      if (!("mainImage" in data)) {
        errors.push("mainImage is missing");
      } else {
        errors.push("mainImage is invalid");
        console.log(data.mainImage);
      }
    }

    if (!validAuctionTime) {
      if (!("auctionTime" in data)) {
        errors.push("auctionTime is missing");
      } else {
        errors.push("auctionTime is invalid");
        console.log(data.auctionTime);
      }
    }

    if (!validBidType) {
      if (!("bidType" in data)) {
        errors.push("bidType is missing");
      } else {
        errors.push("bidType is invalid");
        console.log(data.bidType);
      }
    }

    if (!validStatus) {
      if (!("status" in data)) {
        errors.push("status is missing");
      } else {
        errors.push("status is invalid");
        console.log(data.status);
      }
    }

    if (!validBidBuddy) {
      if (!("bidBuddy" in data)) {
        errors.push("bidBuddy is missing");
      } else {
        errors.push("bidBuddy is invalid");
        console.log(data.bidBuddy);
      }
    }

    if (!validActiveBuddy) {
      if (!("activeBuddy" in data)) {
        errors.push("activeBuddy is missing");
      } else {
        errors.push("activeBuddy is invalid");
        console.log(data.activeBuddy);
      }
    }

    if (!validBuyNow) {
      if (!("buyNow" in data)) {
        errors.push("buyNow is missing");
      } else {
        errors.push("buyNow is invalid");
        console.log(data.buyNow);
      }
    }

    if (!validBidBuddyAmount) {
      if (!("currentBidBuddyAmount" in data)) {
        errors.push("currentBidBuddyAmount is missing");
      } else {
        errors.push("currentBidBuddyAmount is invalid");
        console.log(data.currentBidBuddyAmount);
      }
    }

    if (!validAuctionTimer) {
      if (!("auctionTimer" in data)) {
        errors.push("auctionTimer is missing");
      } else {
        errors.push("auctionTimer is invalid");
        console.log(data.auctionTimer);
      }
    }

    if (!validBuyNowPrice) {
      if (!("buyNowPrice" in data)) {
        errors.push("buyNowPrice is missing");
      } else {
        errors.push("buyNowPrice is invalid");
        console.log(data.buyNowPrice);
      }
    }

    console.log("Invalid SharedProduct");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isShortProduct(data: unknown): data is ShortProduct {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validSharedProduct = isSharedProduct(data);
  const validLastPlacedBid =
    "lastPlacedBid" in data &&
    (data.lastPlacedBid === null || isFullPlacedBid(data.lastPlacedBid));

  const AllValid = validSharedProduct && validLastPlacedBid;

  if (!AllValid) {
    let errors = [];

    if (!validSharedProduct) {
      errors.push("SharedProduct is invalid");
    }

    if (!validLastPlacedBid) {
      if (!("lastPlacedBid" in data)) {
        errors.push("lastPlacedBid is missing");
      } else {
        errors.push("lastPlacedBid is invalid");
        console.log(data.lastPlacedBid);
      }
    }

    console.log("Invalid ShortProduct");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isRewardHistory(data: unknown): data is RewardHistory {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validDates =
    "dates" in data &&
    Array.isArray(data.dates) &&
    data.dates.every((date) => typeof date === "string");
  const validEarned =
    "earned" in data &&
    Array.isArray(data.earned) &&
    data.earned.every(
      (earned) =>
        typeof earned === "object" &&
        earned !== null &&
        "id" in earned &&
        typeof earned.id === "number" &&
        "reward" in earned &&
        typeof earned.reward === "string" &&
        "amount" in earned &&
        typeof earned.amount === "string"
    );

  const AllValid = validDates && validEarned;

  if (!AllValid) {
    let errors = [];

    if (!validDates) {
      if (!("dates" in data)) {
        errors.push("dates is missing");
      } else {
        errors.push("dates is invalid");
        console.log(data.dates);
      }
    }

    if (!validEarned) {
      if (!("earned" in data)) {
        errors.push("earned is missing");
      } else {
        errors.push("earned is invalid");
        console.log(data.earned);
      }
    }
  }

  return AllValid;
}

export function isFullProduct(data: unknown): data is FullProduct {
  if (typeof data !== "object" || data === null) {
    return false;
  }
  if (!isSharedProduct(data)) {
    return false;
  }

  const validDescription =
    "description" in data && typeof data.description === "string";
  const validReviews =
    "reviews" in data &&
    Array.isArray(data.reviews) &&
    data.reviews.every(isProductReview);
  const validAdditionalImages =
    "additionalImages" in data &&
    Array.isArray(data.additionalImages) &&
    data.additionalImages.every(isImageObj);
  const validLastPlacedBids =
    !("lastPlacedBids" in data) ||
    ("lastPlacedBids" in data &&
      Array.isArray(data.lastPlacedBids) &&
      data.lastPlacedBids.every(isFullPlacedBid));
  const validProductID =
    "productId" in data && typeof data.productId === "number";

  const AllValid =
    validDescription &&
    validReviews &&
    validAdditionalImages &&
    validLastPlacedBids &&
    validProductID;

  if (!AllValid) {
    let errors = [];

    if (!validDescription) {
      if (!("description" in data)) {
        errors.push("description is missing");
      } else {
        errors.push("description is invalid");
        console.log(data.description);
      }
    }

    if (!validReviews) {
      if (!("reviews" in data)) {
        errors.push("reviews is missing");
      } else {
        errors.push("reviews is invalid");
        console.log(data.reviews);
      }
    }

    if (!validAdditionalImages) {
      if (!("additionalImages" in data)) {
        errors.push("additionalImages is missing");
      } else {
        errors.push("additionalImages is invalid");
        console.log(data.additionalImages);
      }
    }

    if (!validLastPlacedBids) {
      if (!("lastPlacedBids" in data)) {
        errors.push("lastPlacedBids is missing");
      } else {
        errors.push("lastPlacedBids is invalid");
        console.log(data.lastPlacedBids);
      }
    }

    if (!validProductID) {
      if (!("productId" in data)) {
        errors.push("productId is missing");
      } else {
        errors.push("productId is invalid");
        console.log(data.productId);
      }
    }

    console.log("Invalid FullProduct");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isProductReview(data: object): data is ProductReview {
  const validNickname = "nickname" in data && typeof data.nickname === "string";
  const validProfileImage =
    "profileImage" in data && typeof data.profileImage === "string";
  const validDate = "date" in data && typeof data.date === "string";
  const validRating = "rating" in data && typeof data.rating === "number";
  // Removed RatingStars from reviews
  // const validRatingStars = !!(
  //   "ratingStars" in data &&
  //   data.ratingStars &&
  //   typeof data.ratingStars === "object" &&
  //   isRatingStars(data.ratingStars)
  // );
  const validReview = "review" in data && typeof data.review === "string";

  const AllValid =
    validNickname &&
    validProfileImage &&
    validDate &&
    validRating &&
    validReview;

  if (!AllValid) {
    let errors = [];

    if (!validNickname) {
      if (!("nickname" in data)) {
        errors.push("nickname is missing");
      } else {
        errors.push("nickname is invalid");
      }
    }

    if (!validProfileImage) {
      if (!("profileImage" in data)) {
        errors.push("profileImage is missing");
      } else {
        errors.push("profileImage is invalid");
      }
    }

    if (!validDate) {
      if (!("date" in data)) {
        errors.push("date is missing");
      } else {
        errors.push("date is invalid");
      }
    }

    if (!validRating) {
      if (!("rating" in data)) {
        errors.push("rating is missing");
      } else {
        errors.push("rating is invalid");
      }
    }

    if (!validReview) {
      if (!("review" in data)) {
        errors.push("review is missing");
      } else {
        errors.push("review is invalid");
      }
    }

    console.log("Invalid ProductReview");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isShortUser(data: unknown): data is ShortUser {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validNickname = "nickname" in data && typeof data.nickname === "string";
  const validProfileImage =
    "profileImage" in data &&
    (data.profileImage === null || typeof data.profileImage === "string");

  const AllValid = validNickname && validProfileImage;

  if (!AllValid) {
    let errors = [];

    if (!validNickname) {
      if (!("nickname" in data)) {
        errors.push("nickname is missing");
      } else {
        errors.push("nickname is invalid");
      }
    }

    if (!validProfileImage) {
      if (!("profileImage" in data)) {
        errors.push("profileImage is missing");
      } else {
        errors.push("profileImage is invalid");
      }
    }

    console.log("Invalid ShortUser");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isFullPlacedBid(data: unknown): data is FullPlacedBid {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validProductID =
    "productID" in data && typeof data.productID === "number";
  const validBidAmount =
    "bidAmount" in data && typeof data.bidAmount === "string";
  const validDate = "date" in data && typeof data.date === "string";
  const validBidder = "bidder" in data && isShortUser(data.bidder);
  //    bidBuddyAmount?: number;
  const validCurrentBidBuddyAmount =
    !("currentBidBuddyAmount" in data) ||
    ("currentBidBuddyAmount" in data &&
      typeof data.currentBidBuddyAmount === "number");

  const AllValid =
    validProductID &&
    validBidAmount &&
    validDate &&
    validBidder &&
    validCurrentBidBuddyAmount;

  if (!AllValid) {
    let errors = [];

    if (!validProductID) {
      if (!("productID" in data)) {
        errors.push("productID is missing");
      } else {
        errors.push("productID is invalid");
      }
    }

    if (!validBidAmount) {
      if (!("bidAmount" in data)) {
        errors.push("bidAmount is missing");
      } else {
        errors.push("bidAmount is invalid");
      }
    }

    if (!validDate) {
      if (!("date" in data)) {
        errors.push("date is missing");
      } else {
        errors.push("date is invalid");
      }
    }

    if (!validBidder) {
      if (!("bidder" in data)) {
        errors.push("bidder is missing");
      } else {
        errors.push("bidder is invalid");
      }
    }

    if (!validCurrentBidBuddyAmount) {
      if (!("currentBidBuddyAmount" in data)) {
        errors.push("currentBidBuddyAmount is missing");
      } else {
        errors.push("currentBidBuddyAmount is invalid");
      }
    }

    console.log("Invalid FullPlacedBid");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isImageObj(data: unknown): data is ImageObj {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validFull = "full" in data && typeof data.full === "string";
  const validThumb: boolean =
    ("thumb" in data && typeof data.thumb === "string") || !("thumb" in data);

  const AllValid = validFull || validThumb;

  if (!AllValid) {
    let errors = [];

    if (!validFull) {
      if (!("full" in data)) {
        errors.push("full is missing");
      } else {
        errors.push("full is invalid");
      }
    }

    if (!validThumb) {
      if (!("thumb" in data)) {
        errors.push("thumb is missing");
      } else {
        errors.push("thumb is invalid");
      }
    }

    console.log("Invalid ImageObj");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isBidPack(data: unknown): data is BidPack {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validPrice = "price" in data && typeof data.price === "number";
  const validCurrency = "currency" in data && typeof data.currency === "string";
  const validBids = "bids" in data && typeof data.bids === "number";

  const AllValid = validPrice && validCurrency && validBids;

  if (!AllValid) {
    let errors = [];

    if (!validPrice) {
      if (!("price" in data)) {
        errors.push("price is missing");
      } else {
        errors.push("price is invalid");
      }
    }

    if (!validCurrency) {
      if (!("currency" in data)) {
        errors.push("currency is missing");
      } else {
        errors.push("currency is invalid");
      }
    }

    if (!validBids) {
      if (!("bids" in data)) {
        errors.push("bids is missing");
      } else {
        errors.push("bids is invalid");
      }
    }

    console.log("Invalid BidPack");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isRespViewProfile(data: unknown): data is RespViewProfile {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validFirstName =
    "firstName" in data && typeof data.firstName === "string";
  const validLastName = "lastName" in data && typeof data.lastName === "string";
  const validNickname = "nickname" in data && typeof data.nickname === "string";
  const validEmail = "email" in data && typeof data.email === "string";
  const validProfileImage =
    "profileImage" in data && typeof data.profileImage === "string";
  // const validBoughtBids =
  //   "boughtBids" in data && typeof data.boughtBids === "number";
  // const validAwardedBids =
  //   "awardedBids" in data && typeof data.awardedBids === "number";
  const validLanguage =
    "language" in data &&
    (data.language === null || typeof data.language === "string");
  const validLocation =
    "location" in data &&
    (data.location === null || typeof data.location === "string");

  const AllValid =
    validFirstName &&
    validLastName &&
    validNickname &&
    validEmail &&
    validProfileImage &&
    // validBoughtBids &&
    // validAwardedBids &&
    validLanguage &&
    validLocation;

  if (!AllValid) {
    let errors = [];

    if (!validFirstName) {
      if (!("firstName" in data)) {
        errors.push("firstName is missing");
      } else {
        errors.push("firstName is invalid");
      }
    }

    if (!validLastName) {
      if (!("lastName" in data)) {
        errors.push("lastName is missing");
      } else {
        errors.push("lastName is invalid");
      }
    }

    if (!validNickname) {
      if (!("nickname" in data)) {
        errors.push("nickname is missing");
      } else {
        errors.push("nickname is invalid");
      }
    }

    if (!validEmail) {
      if (!("email" in data)) {
        errors.push("email is missing");
      } else {
        errors.push("email is invalid");
      }
    }

    if (!validProfileImage) {
      if (!("profileImage" in data)) {
        errors.push("profileImage is missing");
      } else {
        errors.push("profileImage is invalid");
      }
    }

    // if (!validBoughtBids) {
    //   if (!("boughtBids" in data)) {
    //     errors.push("boughtBids is missing");
    //   } else {
    //     errors.push("boughtBids is invalid");
    //   }
    // }

    // if (!validAwardedBids) {
    //   if (!("awardedBids" in data)) {
    //     errors.push("awardedBids is missing");
    //   } else {
    //     errors.push("awardedBids is invalid");
    //   }
    // }

    if (!validLanguage) {
      if (!("language" in data)) {
        errors.push("language is missing");
      } else {
        errors.push("language is invalid");
      }
    }

    if (!validLocation) {
      if (!("location" in data)) {
        errors.push("location is missing");
      } else {
        errors.push("location is invalid");
      }
    }

    console.log("Invalid RespViewProfile");
    console.log(data);
    console.log(errors);
  }
  return AllValid;
}

export function isNewAuctionStatus(data: unknown): data is NewAuctionStatus {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validProductID =
    "productID" in data && typeof data.productID === "number";
  const validStatus =
    "status" in data &&
    (data.status === "Not Started" ||
      data.status === "Open" ||
      data.status === "Closed" ||
      data.status === "Ended");

  const AllValid = validProductID && validStatus;

  if (!AllValid) {
    let errors = [];

    if (!validProductID) {
      if (!("productID" in data)) {
        errors.push("productID is missing");
      } else {
        errors.push("productID is invalid");
      }
    }

    if (!validStatus) {
      if (!("status" in data)) {
        errors.push("status is missing");
      } else {
        errors.push("status is invalid");
      }
    }

    console.log("Invalid NewAuctionStatus");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isShippingData(data: unknown): data is ShippingData {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validRecipientName =
    "recipient_name" in data && typeof data.recipient_name === "string";
  const validRecipientMobile =
    "recipient_mobile" in data && typeof data.recipient_mobile === "string";
  const validStreetAddress =
    "street_address" in data && typeof data.street_address === "string";
  const validComplex = "complex" in data && typeof data.complex === "string";
  const validSuburb = "suburb" in data && typeof data.suburb === "string";
  const validCity = "city" in data && typeof data.city === "string";
  const validProvince = "province" in data && typeof data.province === "string";
  const validPostalCode =
    "postal_code" in data && typeof data.postal_code === "string";
  const validCountry = "country" in data && typeof data.country === "string";

  const AllValid =
    validRecipientName &&
    validRecipientMobile &&
    validStreetAddress &&
    validComplex &&
    validSuburb &&
    validCity &&
    validProvince &&
    validPostalCode &&
    validCountry;

  if (!AllValid) {
    let errors = [];

    if (!validRecipientName) {
      if (!("recipientName" in data)) {
        errors.push("recipientName is missing");
      } else {
        errors.push("recipientName is invalid");
      }
    }

    if (!validRecipientMobile) {
      if (!("recipientMobile" in data)) {
        errors.push("recipientMobile is missing");
      } else {
        errors.push("recipientMobile is invalid");
      }
    }

    if (!validStreetAddress) {
      if (!("streetAddress" in data)) {
        errors.push("streetAddress is missing");
      } else {
        errors.push("streetAddress is invalid");
      }
    }

    if (!validComplex) {
      if (!("complex" in data)) {
        errors.push("complex is missing");
      } else {
        errors.push("complex is invalid");
      }
    }

    if (!validSuburb) {
      if (!("suburb" in data)) {
        errors.push("suburb is missing");
      } else {
        errors.push("suburb is invalid");
      }
    }

    if (!validCity) {
      if (!("city" in data)) {
        errors.push("city is missing");
      }
    }

    if (!validProvince) {
      if (!("province" in data)) {
        errors.push("province is missing");
      } else {
        errors.push("province is invalid");
      }
    }

    if (!validPostalCode) {
      if (!("postalCode" in data)) {
        errors.push("postalCode is missing");
      } else {
        errors.push("postalCode is invalid");
      }
    }

    if (!validCountry) {
      if (!("country" in data)) {
        errors.push("country is missing");
      } else {
        errors.push("country is invalid");
      }
    }

    console.log("Invalid ShippingData");
    console.log(data);
    console.log(errors);
  }
  return AllValid;
}

export function isShippingProfileData(
  data: unknown
): data is ShippingProfileData {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validID = "id" in data && typeof data.id === "number";
  const validShippingData = isShippingData(data);

  const AllValid = validID && validShippingData;

  if (!AllValid) {
    let errors = [];

    if (!validID) {
      if (!("id" in data)) {
        errors.push("id is missing");
      } else {
        errors.push("id is invalid");
      }
    }

    if (!validShippingData) {
      errors.push("shippingData is invalid");
    }

    console.log("Invalid ShippingProfileData");
    console.log(data);
    console.log(errors);
  }
  return AllValid;
}

export function isWinningsAuctionItem(
  data: unknown
): data is WinningsAuctionItem {
  if (typeof data !== "object" || data === null) {
    return false;
  }
  // console.log(data);

  const validID = "id" in data && typeof data.id === "number";
  const validTitle = "title" in data && typeof data.title === "string";
  const validPrice = "price" in data && typeof data.price === "string";
  const validFinalPrice =
    "finalPrice" in data && typeof data.finalPrice === "string";
  const validDiscount = "discount" in data && typeof data.discount === "string";
  const validQuantity = "quantity" in data && typeof data.quantity === "number";
  const validStatus =
    "status" in data &&
    (data.status === "Paid" ||
      data.status === "Cart" ||
      typeof data.status === "string");
  const validDate = "date" in data && typeof data.date === "string";
  const validMainImage =
    "mainImage" in data && typeof data.mainImage === "string";
  const validAuctionID =
    !("auctionId" in data) ||
    ("auctionId" in data && typeof data.auctionId === "number");
  const validUploadedPhoto =
    !("uploadedPhoto" in data) ||
    ("uploadedPhoto" in data && typeof data.uploadedPhoto === "string");

  const AllValid =
    validID &&
    validTitle &&
    validPrice &&
    validFinalPrice &&
    validDiscount &&
    validQuantity &&
    validStatus &&
    validDate &&
    validMainImage &&
    validAuctionID &&
    validUploadedPhoto;
  if (!AllValid) {
    let errors = [];

    if (!validID) {
      if (!("id" in data)) {
        errors.push("id is missing");
      } else {
        errors.push("id is invalid");
      }
    }

    if (!validTitle) {
      if (!("title" in data)) {
        errors.push("title is missing");
      } else {
        errors.push("title is invalid");
      }
    }

    if (!validPrice) {
      if (!("price" in data)) {
        errors.push("price is missing");
      } else {
        errors.push("price is invalid");
      }
    }

    if (!validFinalPrice) {
      if (!("finalPrice" in data)) {
        errors.push("finalPrice is missing");
      } else {
        errors.push("finalPrice is invalid");
      }
    }

    if (!validDiscount) {
      if (!("discount" in data)) {
        errors.push("discount is missing");
      } else {
        errors.push("discount is invalid");
      }
    }

    if (!validQuantity) {
      if (!("quantity" in data)) {
        errors.push("quantity is missing");
      } else {
        errors.push("quantity is invalid");
      }
    }

    if (!validStatus) {
      if (!("status" in data)) {
        errors.push("status is missing");
      } else {
        errors.push("status is invalid");
      }
    }

    if (!validDate) {
      if (!("date" in data)) {
        errors.push("date is missing");
      } else {
        errors.push("date is invalid");
      }
    }

    if (!validMainImage) {
      if (!("mainImage" in data)) {
        errors.push("mainImage is missing");
      } else {
        errors.push("mainImage is invalid");
      }
    }

    if (!validAuctionID) {
      if (!("auctionId" in data)) {
        errors.push("auctionId is missing");
      } else {
        errors.push("auctionId is invalid");
      }
    }

    if (!validUploadedPhoto) {
      if (!("uploadedPhoto" in data)) {
        errors.push("uploadedPhoto is missing");
      } else {
        errors.push("uploadedPhoto is invalid");
      }
    }

    console.log("Invalid WinningsAuctionItem");
    console.log(data);
    console.log(errors);
  }
  return AllValid;
}

export function isHistoryFilter(data: unknown): data is HistoryFilter {
  if (!(typeof data === "object") || data === null) {
    return false;
  }

  const validDate =
    "date" in data &&
    Array.isArray(data.date) &&
    data.date.every(
      (item) =>
        Array.isArray(item) &&
        item.length === 2 &&
        typeof item[0] === "number" &&
        typeof item[1] === "string"
    );
  // const validAmount =
  //   "amount" in data &&
  //   Array.isArray(data.amount) &&
  //   data.amount.every(
  //     (item) =>
  //       Array.isArray(item) &&
  //       item.length === 2 &&
  //       typeof item[0] === "string" &&
  //       typeof item[1] === "number"
  //   );
  const validAuction =
    "auction" in data &&
    Array.isArray(data.auction) &&
    data.auction.every(
      (item) =>
        Array.isArray(item) &&
        item.length === 2 &&
        typeof item[0] === "string" &&
        typeof item[1] === "number"
    );

  const allValid = validDate && validAuction;
  if (!allValid) {
    let errors = [];

    if (!validDate) {
      if (!("date" in data)) {
        errors.push("date is missing");
      } else {
        errors.push("date is invalid");
      }
    }

    // if (!validAmount) {
    //   if (!("amount" in data)) {
    //     errors.push("amount is missing");
    //   } else {
    //     errors.push("amount is invalid");
    //   }
    // }

    if (!validAuction) {
      if (!("auction" in data)) {
        errors.push("auction is missing");
      } else {
        errors.push("auction is invalid");
      }
    }

    console.log("Invalid HistoryFilter");
    console.log(data);
    console.log(errors);
  }

  return allValid;
}

export function isHistoryItem(data: unknown): data is HistoryItem {
  if (typeof data !== "object" || data === null) {
    console.log("Invalid HistoryItem - NULL or not an object");
    return false;
  }

  const validAuctionID =
    "auctionID" in data && typeof data.auctionID === "number";
  const validTitle = "title" in data && typeof data.title === "string";
  const validWinner = "winner" in data && typeof data.winner === "string";

  const validImage = "image" in data && isImageObj(data.image);
  const validDate = "date" in data && typeof data.date === "string";

  const AllValid =
    validAuctionID && validTitle && validDate && validImage && validWinner;

  console.log("isHistoryItem ALL VALID: " + AllValid);

  if (!AllValid) {
    let errors = [];

    if (!validAuctionID) {
      if (!("auctionID" in data)) {
        errors.push("auctionID is missing");
      } else {
        errors.push("auctionID is invalid");
      }
    }

    if (!validTitle) {
      if (!("title" in data)) {
        errors.push("title is missing");
      } else {
        errors.push("title is invalid");
      }
    }

    if (!validWinner) {
      if (!("winner" in data)) {
        errors.push("winner is missing");
      } else {
        errors.push("winner is invalid");
      }
    }

    if (!validImage) {
      if (!("image" in data)) {
        errors.push("image is missing");
      } else {
        errors.push("image is invalid");
      }
    }

    if (!validDate) {
      if (!("date" in data)) {
        errors.push("date is missing");
      } else {
        errors.push("date is invalid");
      }
    }

    console.log("Invalid HistoryItem");
    console.log(data);
    console.log(errors);
  }
  return AllValid;
}

export function isWinningProduct(data: unknown): data is WinningProduct {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validID = "id" in data && typeof data.id === "number";
  const validTitle = "title" in data && typeof data.title === "string";
  const validProductImage =
    "productImage" in data && typeof data.productImage === "string";
  const validCurrentAmount =
    "currentAmount" in data && typeof data.currentAmount === "string";
  const validPrice = "price" in data && typeof data.price === "string";
  const validBidsPlaced =
    "bidsPlaced" in data && typeof data.bidsPlaced === "number";
  const validTotalCost =
    "totalCost" in data && typeof data.totalCost === "string";
  const validEndTime = "endTime" in data && typeof data.endTime === "string";
  const validBidderImage =
    "bidderImage" in data && typeof data.bidderImage === "string";
  const validBidderName =
    "bidderName" in data && typeof data.bidderName === "string";

  const AllValid =
    validID &&
    validTitle &&
    validProductImage &&
    validCurrentAmount &&
    validPrice &&
    validBidsPlaced &&
    validTotalCost &&
    validEndTime &&
    validBidderImage &&
    validBidderName;

  if (!AllValid) {
    let errors = [];

    if (!validID) {
      if (!("id" in data)) {
        errors.push("id is missing");
      } else {
        errors.push("id is invalid");
      }
    }

    if (!validTitle) {
      if (!("title" in data)) {
        errors.push("title is missing");
      } else {
        errors.push("title is invalid");
      }
    }

    if (!validProductImage) {
      if (!("productImage" in data)) {
        errors.push("productImage is missing");
      } else {
        errors.push("productImage is invalid");
      }
    }

    if (!validCurrentAmount) {
      if (!("currentAmount" in data)) {
        errors.push("currentAmount is missing");
      } else {
        errors.push("currentAmount is invalid");
      }
    }

    if (!validPrice) {
      if (!("price" in data)) {
        errors.push("price is missing");
      } else {
        errors.push("price is invalid");
      }
    }

    if (!validBidsPlaced) {
      if (!("bidsPlaced" in data)) {
        errors.push("bidsPlaced is missing");
      } else {
        errors.push("bidsPlaced is invalid");
      }
    }

    if (!validTotalCost) {
      if (!("totalCost" in data)) {
        errors.push("totalCost is missing");
      } else {
        errors.push("totalCost is invalid");
      }
    }

    if (!validEndTime) {
      if (!("endTime" in data)) {
        errors.push("endTime is missing");
      } else {
        errors.push("endTime is invalid");
      }
    }

    if (!validBidderImage) {
      if (!("bidderImage" in data)) {
        errors.push("bidderImage is missing");
      } else {
        errors.push("bidderImage is invalid");
      }
    }

    if (!validBidderName) {
      if (!("bidderName" in data)) {
        errors.push("bidderName is missing");
      } else {
        errors.push("bidderName is invalid");
      }
    }

    console.log("Invalid WinningProducts");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isBidderFavoriteProducts(
  data: unknown
): data is FavoriteProducts {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validID = "id" in data && typeof data.id === "number";
  const validTitle = "title" in data && typeof data.title === "string";
  const validMainImage =
    "mainImage" in data && typeof data.mainImage === "string";
  const validCurrentAmount =
    "currentAmount" in data && typeof data.currentAmount === "string";

  const AllValid =
    validID && validTitle && validMainImage && validCurrentAmount;

  if (!AllValid) {
    let errors = [];

    if (!validID) {
      if (!("id" in data)) {
        errors.push("id is missing");
      } else {
        errors.push("id is invalid");
      }
    }

    if (!validTitle) {
      if (!("title" in data)) {
        errors.push("title is missing");
      } else {
        errors.push("title is invalid");
      }
    }

    if (!validMainImage) {
      if (!("mainImage" in data)) {
        errors.push("mainImage is missing");
      } else {
        errors.push("mainImage is invalid");
      }
    }

    if (!validCurrentAmount) {
      if (!("currentAmount" in data)) {
        errors.push("currentAmount is missing");
      } else {
        errors.push("currentAmount is invalid");
      }
    }

    console.log("Invalid BidderActiveProducts");
    console.log(data);
    console.log(errors);
  }
  return AllValid;
}

export function isResponseSearchFilterOptions(
  data: unknown
): data is ResponseSearchFilterOptions {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validCategory =
    "category" in data &&
    Array.isArray(data.category) &&
    data.category.every((item) => typeof item === "number");
  // const validPrice =
  //   "price" in data &&
  //   typeof (data as { price: Record<string, unknown> }).price === "object" &&
  //   (data as { price: Record<string, unknown> }).price !== null &&
  //   Object.keys((data as { price: Record<string, unknown> }).price).every(
  //     (key) =>
  //       typeof key === "string" &&
  //       typeof (data as { price: Record<string, unknown> }).price[key] ===
  //         "number"
  //   );
  const validPrice = "price" in data && typeof data.price === "number";
  // const validAvailable =
  //   "available" in data &&
  //   Array.isArray(data.available) &&
  //   data.available.every((item) => typeof item === "number");
  const validRating =
    "rating" in data &&
    Array.isArray(data.rating) &&
    data.rating.every((item) => typeof item === "number");
  const validBidType =
    "bidType" in data &&
    Array.isArray(data.bidType) &&
    data.bidType.every((item) => typeof item === "string");
  const validStatus =
    "status" in data &&
    Array.isArray(data.status) &&
    data.status.every((item) => typeof item === "string");

  const AllValid =
    validCategory &&
    validPrice &&
    // validAvailable &&
    validRating &&
    validBidType &&
    validStatus;

  if (!AllValid) {
    let errors = [];

    if (!validCategory) {
      if (!("category" in data)) {
        errors.push("category is missing");
      } else {
        errors.push("category is invalid");
      }
    }

    if (!validPrice) {
      if (!("price" in data)) {
        errors.push("price is missing");
      } else {
        errors.push("price is invalid");
      }
    }

    // if (!validAvailable) {
    //   if (!("available" in data)) {
    //     errors.push("available is missing");
    //   } else {
    //     errors.push("available is invalid");
    //   }
    // }

    if (!validRating) {
      if (!("rating" in data)) {
        errors.push("rating is missing");
      } else {
        errors.push("rating is invalid");
      }
    }

    if (!validBidType) {
      if (!("bidType" in data)) {
        errors.push("bidType is missing");
      } else {
        errors.push("bidType is invalid");
      }
    }

    if (!validStatus) {
      if (!("status" in data)) {
        errors.push("status is missing");
      } else {
        errors.push("status is invalid");
      }
    }

    console.log("Invalid ResponseSearchFilterOptions");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isSearchFilterOptions(
  data: unknown
): data is SearchFilterOptions {
  return true;
}

export function isAddToCart(data: unknown): data is CartItem[] {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  if ("cartItems" in data && Array.isArray(data.cartItems)) {
    return data.cartItems.every((item) => {
      return isCartItem(item);
    });
  }

  return false;
}

function isCartItem(data: unknown): data is CartItem {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validAuctionID =
    !("auctionId" in data) ||
    ("auctionId" in data && typeof data.auctionId === "number");
  const validProductID =
    !("productId" in data) ||
    ("productId" in data && typeof data.productId === "number");
  const validAmount = "amount" in data && typeof data.amount === "number";
  const validType = "type" in data && typeof data.type === "string";
  const validName = "name" in data && typeof data.name === "string";
  const validImage =
    !("image" in data) || ("image" in data && typeof data.image === "string");
  const validNewAmount =
    !("newAmount" in data) ||
    ("newAmount" in data && typeof data.newAmount === "number");
  const validOrderID =
    !("orderId" in data) ||
    ("orderId" in data && typeof data.orderId === "number");
  // quantity
  const validQuantity =
    !("quantity" in data) ||
    ("quantity" in data && typeof data.quantity === "number");

  const validBidAmount =
    !("bidAmount" in data) ||
    ("bidAmount" in data && typeof data.bidAmount === "number");

  const AllValid =
    validAuctionID &&
    validProductID &&
    validAmount &&
    validType &&
    validName &&
    validImage &&
    validNewAmount &&
    validOrderID &&
    validQuantity &&
    validBidAmount;
  if (!AllValid) {
    let errors = [];

    if (!validAuctionID) {
      if (!("auctionId" in data)) {
        errors.push("auctionId is missing");
      } else {
        errors.push("auctionId is invalid");
      }
    }

    if (!validProductID) {
      if (!("productId" in data)) {
        errors.push("productId is missing");
      } else {
        errors.push("productId is invalid");
      }
    }

    if (!validAmount) {
      if (!("amount" in data)) {
        errors.push("amount is missing");
      } else {
        errors.push("amount is invalid");
      }
    }

    if (!validType) {
      if (!("type" in data)) {
        errors.push("type is missing");
      } else {
        errors.push("type is invalid");
      }
    }

    if (!validName) {
      if (!("name" in data)) {
        errors.push("name is missing");
      } else {
        errors.push("name is invalid");
      }
    }

    if (!validImage) {
      if (!("image" in data)) {
        errors.push("image is missing");
      } else {
        errors.push("image is invalid");
      }
    }

    if (!validNewAmount) {
      if (!("newAmount" in data)) {
        errors.push("newAmount is missing");
      } else {
        errors.push("newAmount is invalid");
      }
    }

    if (!validOrderID) {
      if (!("orderId" in data)) {
        errors.push("orderId is missing");
      } else {
        errors.push("orderId is invalid");
      }
    }

    if (!validQuantity) {
      if (!("quantity" in data)) {
        errors.push("quantity is missing");
      } else {
        errors.push("quantity is invalid");
      }
    }

    if (!validBidAmount) {
      if (!("bidAmount" in data)) {
        errors.push("bidAmount is missing");
      } else {
        errors.push("bidAmount is invalid");
      }
    }

    console.log("Invalid CartItem");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isLatestBid(data: unknown): data is NewBidPopup {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validBidAmount =
    "bidAmount" in data && typeof data.bidAmount === "string";
  const validBidderLocation =
    "bidderLocation" in data && typeof data.bidderLocation === "string";
  const validNickname = "nickname" in data && typeof data.nickname === "string";
  const validProductImage =
    "productImage" in data && typeof data.productImage === "string";

  const AllValid =
    validBidAmount && validBidderLocation && validNickname && validProductImage;

  if (!AllValid) {
    let errors = [];

    if (!validBidAmount) {
      if (!("bidAmount" in data)) {
        errors.push("bidAmount is missing");
      } else {
        errors.push("bidAmount is invalid");
      }
    }

    if (!validBidderLocation) {
      if (!("bidderLocation" in data)) {
        errors.push("bidderLocation is missing");
      } else {
        errors.push("bidderLocation is invalid");
      }
    }

    if (!validNickname) {
      if (!("nickname" in data)) {
        errors.push("nickname is missing");
      } else {
        errors.push("nickname is invalid");
      }
    }
    if (!validProductImage) {
      if (!("productImage" in data)) {
        errors.push("productImage is missing");
      } else {
        errors.push("productImage is invalid");
      }
    }

    console.log("Invalid LatestBid");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isNewRewardPopup(data: unknown): data is NewRewardPopup {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validBids = "bids" in data && typeof data.bids === "number";
  const validType = "type" in data && typeof data.type === "string";

  const AllValid = validBids && validType;

  if (!AllValid) {
    let errors = [];

    if (!validBids) {
      if (!("bids" in data)) {
        errors.push("bids is missing");
      } else {
        errors.push("bids is invalid");
      }
    }

    if (!validType) {
      if (!("type" in data)) {
        errors.push("type is missing");
      } else {
        errors.push("type is invalid");
      }
    }

    console.log("Invalid NewRewardPopup");
    console.log(data);
    console.log(errors);
  }
  return AllValid;
}

export function isWinningsFilterOptions(
  data: unknown
): data is WinningsFilterOptions {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validStatus =
    "status" in data &&
    Array.isArray(data.status) &&
    data.status.every(
      (item) =>
        Array.isArray(item) &&
        item.length === 2 &&
        typeof item[0] === "string" &&
        typeof item[1] === "string"
    );
  // const validCourier =
  //   "courier" in data &&
  //   Array.isArray(data.courier) &&
  //   data.courier.every(
  //     (item) =>
  //       Array.isArray(item) &&
  //       item.length === 2 &&
  //       typeof item[0] === "string" &&
  //       typeof item[1] === "string"
  //   );
  // const validTracking =
  //   "tracking" in data &&
  //   Array.isArray(data.tracking) &&
  //   data.tracking.every(
  //     (item) =>
  //       Array.isArray(item) &&
  //       item.length === 2 &&
  //       typeof item[0] === "string" &&
  //       typeof item[1] === "string"
  //   );
  // const validDaysLeft =
  //   "daysLeft" in data &&
  //   Array.isArray(data.daysLeft) &&
  //   data.daysLeft.every(
  //     (item) =>
  //       Array.isArray(item) &&
  //       item.length === 2 &&
  //       typeof item[0] === "string" &&
  //       typeof item[1] === "number"
  //   );
  // const validPaid =
  //   "paid" in data &&
  //   Array.isArray(data.paid) &&
  //   data.paid.every(
  //     (item) =>
  //       Array.isArray(item) &&
  //       item.length === 2 &&
  //       typeof item[0] === "string" &&
  //       typeof item[1] === "string"
  //   );

  const AllValid = validStatus;
  // && validCourier && validTracking && validDaysLeft && validPaid;

  if (!AllValid) {
    let errors = [];

    if (!validStatus) {
      if (!("status" in data)) {
        errors.push("status is missing");
      } else {
        errors.push("status is invalid");
      }
    }

    // if (!validCourier) {
    //   if (!("courier" in data)) {
    //     errors.push("courier is missing");
    //   } else {
    //     errors.push("courier is invalid");
    //   }
    // }

    // if (!validTracking) {
    //   if (!("tracking" in data)) {
    //     errors.push("tracking is missing");
    //   } else {
    //     errors.push("tracking is invalid");
    //   }
    // }

    // if (!validDaysLeft) {
    //   if (!("daysLeft" in data)) {
    //     errors.push("daysLeft is missing");
    //   } else {
    //     errors.push("daysLeft is invalid");
    //   }
    // }

    // if (!validPaid) {
    //   if (!("paid" in data)) {
    //     errors.push("paid is missing");
    //   } else {
    //     errors.push("paid is invalid");
    //   }
    // }

    console.log("Invalid WinningsFilterOptions");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function isApiPaymentGateWay(data: unknown): data is ApiPaymentGateWay {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const validID = "id" in data && typeof data.id === "number";
  const validPaymentGateway =
    "payment_gateway" in data && typeof data.payment_gateway === "string";

  const AllValid = validID && validPaymentGateway;

  if (!AllValid) {
    let errors = [];

    if (!validID) {
      if (!("id" in data)) {
        errors.push("id is missing");
      } else {
        errors.push("id is invalid");
      }
    }

    if (!validPaymentGateway) {
      if (!("payment_gateway" in data)) {
        errors.push("payment_gateway is missing");
      } else {
        errors.push("payment_gateway is invalid");
      }
    }

    console.log("Invalid ApiPaymentGateWays");
    console.log(data);
    console.log(errors);
  }

  return AllValid;
}

export function validateChatMessages(messages: ChatMessage[]): boolean {
  if (
    !messages ||
    typeof messages === "undefined" ||
    typeof messages === "undefined"
  ) {
    console.error("Error - Attempt to send send messages - but none found");
    return false;
  } else if (!Array.isArray(messages)) {
    console.error("Error - Attempt to send send messages - but not an array");
    return false;
  }

  // ----------------------------
  // validate messages
  const invalidMessages = messages.filter((message) => {
    if (
      typeof message.ai === "undefined" ||
      message.ai === null ||
      typeof message.ai !== "boolean"
    ) {
      return message;
    } else if (
      !message.content ||
      typeof message.content !== "string" ||
      message.content.trim() === ""
    ) {
      return message;
    } else if (
      !message.time ||
      typeof message.time !== "number" ||
      message.time <= 0
    ) {
      return message;
    } else if (
      typeof message.system === "undefined" ||
      message.system === null ||
      typeof message.system !== "boolean"
    ) {
      return message;
    }
    return null;
  });

  if (invalidMessages.length > 0) {
    try {
      console.error(
        "Error - Attempt to send send messages - invalid found. List of Messages"
      );
      invalidMessages.map((message) => {
        console.error("Invalid Message", message);
      });

      return false;
    } catch (error) {
      console.error(
        "There was an error for messages to be sent, and an error in displaying them as:",
        error
      );
      return false;
    }
  }

  return true;
}
